<template>
    <div class="table">
        <div class="table--row" v-for="baseLevel in clientBaseLevels" :key="baseLevel.BaseType" :class="baseLevel.baseType.toLowerCase()" >
            <span class="table--base-level">
                {{baseLevel.baseType}}
            </span>
            <span class="table--base-value" v-for="baseValue in baseLevel.dna" :key="baseValue.id">
                <span v-if="dotLevels.includes(baseLevel.baseType.toLowerCase())"
                    class="table--dot"
                    :class="['table--dot'+baseValue.value, {border : baseValue.fixed}]">
                </span>
                <span v-else>
                    <span :class="{'table--underline' : baseValue.strength, fixed: baseValue.fixed}">{{baseValue.value}}</span>
                </span>
            </span>
        </div>
    </div>
</template>

<script>
import {getFullSleepDnaFromMeasurement} from "@/utils/utils.js";

export default {
    name : "DNATable",
    props: {
        result: {
            type: Object
        }
    },
    data() {
        return {
            dotLevels: ["bs4", "bs3", "bs1"]
        };
    },

    computed: {
        clientBaseLevels() {
            let baseTypes = ["P4", "P3", "P1", "BS4", "BS3", "BS1"];
            let fullDna = getFullSleepDnaFromMeasurement(this.result.BaseLevels);
            fullDna.sort((x, y) => baseTypes.indexOf(x.baseType) > baseTypes.indexOf(y.baseType) ? 1 : -1);
            return fullDna;
        }
    }
};
</script>

<style lang="scss" scoped>
    .table {
        color : #000;
        font-size: 1em;
        border : solid .1rem $color-grey;
        border-radius: 1rem;
        height: 12.1rem;

        &--row {
            display: flex;
            width:100%;
            justify-content: space-evenly;
            height: 1.98rem;
            align-items: center;


            .table--base-value {
                .fixed {
                    color : #9D9C9C;
                }
            }

        }
        &--base-level {
            width : 10%;
            border-right : solid .1rem $color-grey;
            height: 100%;
            display: flex;
            align-items: center;
        }

        &--base-value {
            text-align: center;
            width : .8rem;
        }

        &--dot {
            display: inline-block;
            width : .9rem;
            height : .9rem;
            border-radius: 50%;
            position: relative;

            &.border::after {
                content : ' ';
                border : solid .3rem #C6C6C6;
                width : .6rem;
                height : .6rem;
                top : -0.15rem;
                left : -0.15rem;
                position: absolute;
                border-radius: 50%;
            }

            &1 {
                background : $color-green;
            }
            &2 {
                background : $color-yellow;
            }
            &3 {
                background : $color-red;
            }
            &4 {
                background : $color-blue;
            }
        }

        &--underline {
            position: relative;
            &:after {
                content : ' ';
                border-bottom: solid 0.15rem #000000;
                position: absolute;
                bottom: -0.3rem;
                left: -0.2rem;
                right: -0.2rem;
            }
        }

    }
</style>